import { useEffect, useMemo, useState } from 'react'
import {
    CommonConstant,
    GroupService,
    ErrorConstant,
    PaginationType,
} from 'utility'

export const GetGroupList = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        unique_id: undefined,
        all: paginationType,
    })

    const options = useMemo(
        () => data.map(ele => ({ value: ele.GroupId, text: ele.GroupName })),
        [data],
    )

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await GroupService.list(
                    !filter.all ? filter : {},
                )
                setData(result.Items)
                setTotalCount(result.TotalCount)
                // console.log(result)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [filter, paginationType])

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const filterChanged = data => {
        setFilter({
            ...filter,
            ...data,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        options,
        setData,
        error,
        loading,
        filter,
        totalCount,
        pageChanged,
        refresh,
        filterChanged,
    }
}
export const GetTeamGroupCapa = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        unique_id: undefined,
        all: paginationType,
    })
    const options = useMemo(
        () => data.map(ele => ({ value: ele.GroupId, text: ele.GroupId })),
        [data],
    )
    console.log('options', options)
    // useEffect(() => {
    //     const fetchCapaData = async () => {
    //         try {
    //             setLoading(true)
    //             const result = await GroupService.getTeamGroupCapa(
    //                 !filter.all ? filter : {},
    //             )

    //             setData(result)
    //             console.log(result.Records)
    //             setTotalCount(result.TotalCount)
    //         } catch (err) {
    //             setError(ErrorConstant.default)
    //         } finally {
    //             setLoading(false)
    //         }
    //     }
    //     fetchCapaData()
    // }, [filter, paginationType])
    useEffect(() => {
        let isMounted = true // Track mounted state

        const fetchCapaData = async () => {
            try {
                setLoading(true)
                const result = await GroupService.getTeamGroupCapa(
                    !filter.all ? filter : {},
                )

                if (isMounted) {
                    // Only update state if the component is still mounted
                    setData(result.Records || [])
                    setTotalCount(result.TotalCount || 0)
                }
            } catch (err) {
                if (isMounted) setError(ErrorConstant.default)
            } finally {
                if (isMounted) setLoading(false)
            }
        }

        fetchCapaData()

        return () => {
            isMounted = false
        }
    }, [filter, paginationType])

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const filterChanged = data => {
        setFilter({
            ...filter,
            ...data,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        options,
        setData,
        error,
        loading,
        filter,
        totalCount,
        pageChanged,
        refresh,
        filterChanged,
    }
}
